import { ENDPOINTS, PAGE_SIZE_DEFAULT_MAX } from '@constants';
import APIManager from '@services';
import { DeviceUtils } from '@utils';
import { useState } from 'react';

import { useMutationEnhancer } from '../core';

export const useMutateFetchOperationReportData = () => {
  const [dataReturn, setDataReturn] = useState<any | undefined>(undefined);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data, ...rest } = useMutationEnhancer<any, any>({
    mutationFn: async mParams => {
      const res = await APIManager.request({
        url: ENDPOINTS.transportJob('report-excel-data'),
        body: {
          page: 0,
          size: PAGE_SIZE_DEFAULT_MAX,
          ...mParams
        }
      });

      return res.data;
    },
    onSuccess: d => {
      setDataReturn(d);
    }
  });

  return {
    ...rest,
    data: dataReturn,
    setDataReturn
  };
};

export const useExportOperationReportData = () => {
  return useMutationEnhancer<any, any>({
    mutationFn: async mParams => {
      const res = await APIManager.request({
        url: ENDPOINTS.transportJob('export-excel-template'),
        body: mParams
      });

      return res.data;
    },
    onSuccess: d => {
      if (!!d?.success && d?.payload) {
        DeviceUtils.downloadFile({
          contentType: d.payload.contentType,
          fileName: d.payload.fileName,
          base64: d.payload.bytes
        });
      }
    }
  });
};
